import { Component, OnInit } from '@angular/core';
//

import Map from 'ol/Map';
import View from 'ol/View';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
//import Style from 'ol/style/Style';
import { Fill, Stroke, Style, Text } from 'ol/style';
import IconAnchorUnits from 'ol/style/IconAnchorUnits';
import GeoJSON from 'ol/format/GeoJSON';
import Icon from 'ol/style/Icon';
import OSM from 'ol/source/OSM';
import * as olProj from 'ol/proj';
//import TileLayer from 'ol/layer/Tile';

import ImageWMS from 'ol/source/ImageWMS';
import Overlay from 'ol/Overlay';
import { Group as LayerGroup, Image as ImageLayer, Tile as TileLayer } from 'ol/layer';
import { Coordinate, toStringHDMS } from 'ol/coordinate';
import { URL_GEOSERVER, URL_WEB_SERVER } from '../global/config'
import { Lote } from '../models/Lote';
import { IFicha } from '../models/IFicha';
import { FichaService } from '../services/ficha.service';
import { IFichaResumen } from '../models/IFichaResumen';
import { ReporteGeneralFichaService } from '../services/ReporteGeneralFicha.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalResumenFichaComponent } from '../components/ModalResumenFicha/ModalResumenFicha.component';
declare var $: any;

@Component({
  selector: 'app-mapaol',
  templateUrl: './mapaol.component.html',
  styleUrls: ['./mapaol.component.css']
})
export class MapaolComponent implements OnInit {

  //PROPIEDADES------------------------------------------------------------------------------
  map: Map;
  view: View = new View({
    center: olProj.fromLonLat([-71.9774868, -13.5169427]),
    zoom: 15
  });
  overlay: Overlay;
  infoElemento: Lote;
  infoFichaCatalogacion: IFicha;
  infoFichaResumen: IFichaResumen;
  // CONFIG-GEOSERVER-PROVIDER:
  //urlGeoserver: string = 'http://172.16.7.144:8080/geoserver/gchc.catalogacion/wms'; 
  urlWebServer: string = URL_WEB_SERVER.UrlWebServer;
  urlGeoserverOld: string = 'http://localhost:8080/geoserver/gchc.catalogacion/wms';
  urlGeoserver: string = URL_GEOSERVER.UrlGeoserver;
  lotesWmsSource: ImageWMS = new ImageWMS({
    url: this.urlGeoserver,
    params: { 'LAYERS': 'gchc.catalogacion:lotes', 'TILED': true },
    serverType: 'geoserver',
    //transition: 0,
  });
  viewTocMap: boolean = true;
  //FIN - PROPIEDADES------------------------------------------------------------------------- 

  //closer = document.getElementById('popup-closer');
  viewPopup: Boolean = false;

  constructor(
    private fichaService: FichaService,
    private _reporteGeneralFichaService: ReporteGeneralFichaService,
    private _modalService: NgbModal
  ) { }

  ngOnInit(): void {
    var closer = document.getElementById('popup-closer');

    //---------------------------------------------------------------
    $(document).ready(function () {
      /// alert('we call alert from JQuery');

      $('#layertree li > span')
        .click(function () {
          $(this).siblings('fieldset').toggle();
        })
        .siblings('fieldset')
        .hide();



    });


    //---------------------------------------------------------------


    this.overlay = new Overlay({
      element: document.getElementById('popup'),
      autoPan: true,
      autoPanAnimation: {
        duration: 250,
      },
    });


    closer.onclick = () => {
      this.overlay.setPosition(undefined);
      closer.blur();
      return false;
    };

    this.map = new Map({
      target: 'hotel_map',
      layers: [
        new TileLayer({
          source: new OSM()
        }),
        new LayerGroup({
          layers: [
            new ImageLayer({
              //title: 'Inmebles Relig. Bloques 1er Nivel',
              source: new ImageWMS({
                url: this.urlGeoserver,
                params: { 'LAYERS': 'gchc.catalogacion:borde_gchc', 'TILED': true },
                serverType: 'geoserver',
                // Countries have transparency, so do not fade tiles:
                //transition: 0,
              }),
            }),
            new ImageLayer({

              //title: 'Inmebles Relig. Bloques 1er Nivel',
              source: new ImageWMS({
                url: this.urlGeoserver,
                params: { 'LAYERS': 'gchc.catalogacion:sectores', 'TILED': true },
                serverType: 'geoserver',
                // Countries have transparency, so do not fade tiles:
                //transition: 0,
              }),
            }),


            new ImageLayer({
              //title: 'Sectores',
              visible: true,
              source: new ImageWMS({

                url: this.urlGeoserver,
                //params: {'LAYERS': URL_WS_V2+'sectores','STYLES': 'cat_sectores_only_label_sld', 'TILED': true},
                params: { 'LAYERS': 'gchc.catalogacion:lotes', 'TILED': true },
                serverType: 'geoserver',
                // Countries have transparency, so do not fade tiles:
                //transition: 0,
              })
            }),
            new ImageLayer({
              //title: 'Sectores',
              visible: true,
              source: new ImageWMS({

                url: this.urlGeoserver,
                //params: {'LAYERS': URL_WS_V2+'sectores','STYLES': 'cat_sectores_only_label_sld', 'TILED': true},
                params: { 'LAYERS': 'gchc.catalogacion:lotes_inmuebles_religiosos', 'TILED': true },
                serverType: 'geoserver',
                // Countries have transparency, so do not fade tiles:
                //transition: 0,
              })
            }),
            new ImageLayer({
              //title: 'Sectores',
              visible: true,
              source: new ImageWMS({

                url: this.urlGeoserver,
                //params: {'LAYERS': URL_WS_V2+'sectores','STYLES': 'cat_sectores_only_label_sld', 'TILED': true},
                params: { 'LAYERS': 'gchc.catalogacion:area_no_catalogada', 'TILED': true },
                serverType: 'geoserver',
                // Countries have transparency, so do not fade tiles:
                //transition: 0,
              })
            }),
            new ImageLayer({
              //title: 'Inmebles Relig. Bloques 1er Nivel',
              visible: true,
              source: new ImageWMS({
                url: this.urlGeoserver,
                params: { 'LAYERS': 'gchc.catalogacion:sectores', 'STYLES': 'cat_sectores_only_label_sld', 'TILED': true },
                serverType: 'geoserver',
                // Countries have transparency, so do not fade tiles:
                //transition: 0,
              }),
            }),
            /*
            new VectorLayer({
              source: new VectorSource({
                url: 'http://172.16.7.144:8080/geoserver/gchc.catalogacion/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=gchc.catalogacion%3Ainn&maxFeatures=50&outputFormat=application%2Fjson',
                format: new GeoJSON({
                  //dataProjection: 'EPSG:32718',
                  featureProjection: 'EPSG:4326',
                  //defaultDataProjection: 'EPSG:4326'
                })
              }),
              style: new Style({
                image: new Icon({
                  anchor: [0.5, 46],
                  anchorXUnits: IconAnchorUnits.FRACTION,
                  anchorYUnits: IconAnchorUnits.PIXELS,
                  src: 'http://openlayers.org/en/latest/examples/data/icon.png'
                })
              })
            })*/
          ]

        }),
        /* SECTOR 01 */
        new LayerGroup({

          layers: [
            new ImageLayer({
              //title: 'Sectores',
              visible: false,
              source: new ImageWMS({

                url: this.urlGeoserver,
                //params: {'LAYERS': URL_WS_V2+'sectores','STYLES': 'cat_sectores_only_label_sld', 'TILED': true},
                params: { 'LAYERS': 'gchc.catalogacion:sg01_lotes_bloques_s1', 'TILED': true },
                serverType: 'geoserver',
                // Countries have transparency, so do not fade tiles:
                //transition: 0,
              })
            }),
            new ImageLayer({
              //title: 'Sectores',
              visible: false,
              source: new ImageWMS({

                url: this.urlGeoserver,
                //params: {'LAYERS': URL_WS_V2+'sectores','STYLES': 'cat_sectores_only_label_sld', 'TILED': true},
                params: { 'LAYERS': 'gchc.catalogacion:sg01_lotes_bloques_s2', 'TILED': true },
                serverType: 'geoserver',
                // Countries have transparency, so do not fade tiles:
                //transition: 0,
              })
            }),
            new ImageLayer({
              //title: 'Sectores',
              visible: false,
              source: new ImageWMS({

                url: this.urlGeoserver,
                //params: {'LAYERS': URL_WS_V2+'sectores','STYLES': 'cat_sectores_only_label_sld', 'TILED': true},
                params: { 'LAYERS': 'gchc.catalogacion:sg01_lotes_bloques_n1', 'TILED': true },
                serverType: 'geoserver',
                // Countries have transparency, so do not fade tiles:
                //transition: 0,
              })
            }),
            new ImageLayer({
              //title: 'Sectores',
              visible: false,
              source: new ImageWMS({

                url: this.urlGeoserver,
                //params: {'LAYERS': URL_WS_V2+'sectores','STYLES': 'cat_sectores_only_label_sld', 'TILED': true},
                params: { 'LAYERS': 'gchc.catalogacion:sg01_lotes_bloques_n2', 'TILED': true },
                serverType: 'geoserver',
                // Countries have transparency, so do not fade tiles:
                //transition: 0,
              })
            }),
            new ImageLayer({
              //title: 'Sectores',
              visible: false,
              source: new ImageWMS({

                url: this.urlGeoserver,
                //params: {'LAYERS': URL_WS_V2+'sectores','STYLES': 'cat_sectores_only_label_sld', 'TILED': true},
                params: { 'LAYERS': 'gchc.catalogacion:sg01_lotes_bloques_n3', 'TILED': true },
                serverType: 'geoserver',
                // Countries have transparency, so do not fade tiles:
                //transition: 0,
              })
            }),
            new ImageLayer({
              //title: 'Sectores',
              visible: false,
              source: new ImageWMS({

                url: this.urlGeoserver,
                //params: {'LAYERS': URL_WS_V2+'sectores','STYLES': 'cat_sectores_only_label_sld', 'TILED': true},
                params: { 'LAYERS': 'gchc.catalogacion:sg01_lotes_bloques_n4', 'TILED': true },
                serverType: 'geoserver',
                // Countries have transparency, so do not fade tiles:
                //transition: 0,
              })
            }),
            new ImageLayer({
              //title: 'Sectores',
              visible: false,
              source: new ImageWMS({

                url: this.urlGeoserver,
                //params: {'LAYERS': URL_WS_V2+'sectores','STYLES': 'cat_sectores_only_label_sld', 'TILED': true},
                params: { 'LAYERS': 'gchc.catalogacion:sg01_lotes_bloques_n5', 'TILED': true },
                serverType: 'geoserver',
                // Countries have transparency, so do not fade tiles:
                //transition: 0,
              })
            }),
          ]
        }),
        /* SECTOR 02 */
        new LayerGroup({

          layers: [
            new ImageLayer({
              //title: 'Sectores',
              visible: false,
              source: new ImageWMS({

                url: this.urlGeoserver,
                //params: {'LAYERS': URL_WS_V2+'sectores','STYLES': 'cat_sectores_only_label_sld', 'TILED': true},
                params: { 'LAYERS': 'gchc.catalogacion:sg02_lotes_bloques_s1', 'TILED': true },
                serverType: 'geoserver',
                // Countries have transparency, so do not fade tiles:
                //transition: 0,
              })
            }),

            new ImageLayer({
              //title: 'Sectores',
              visible: false,
              source: new ImageWMS({

                url: this.urlGeoserver,
                //params: {'LAYERS': URL_WS_V2+'sectores','STYLES': 'cat_sectores_only_label_sld', 'TILED': true},
                params: { 'LAYERS': 'gchc.catalogacion:sg02_lotes_bloques_n1', 'TILED': true },
                serverType: 'geoserver',
                // Countries have transparency, so do not fade tiles:
                //transition: 0,
              })
            }),
            new ImageLayer({
              //title: 'Sectores',
              visible: false,
              source: new ImageWMS({

                url: this.urlGeoserver,
                //params: {'LAYERS': URL_WS_V2+'sectores','STYLES': 'cat_sectores_only_label_sld', 'TILED': true},
                params: { 'LAYERS': 'gchc.catalogacion:sg02_lotes_bloques_n2', 'TILED': true },
                serverType: 'geoserver',
                // Countries have transparency, so do not fade tiles:
                //transition: 0,
              })
            }),
            new ImageLayer({
              //title: 'Sectores',
              visible: false,
              source: new ImageWMS({

                url: this.urlGeoserver,
                //params: {'LAYERS': URL_WS_V2+'sectores','STYLES': 'cat_sectores_only_label_sld', 'TILED': true},
                params: { 'LAYERS': 'gchc.catalogacion:sg02_lotes_bloques_n3', 'TILED': true },
                serverType: 'geoserver',
                // Countries have transparency, so do not fade tiles:
                //transition: 0,
              })
            }),
            new ImageLayer({
              //title: 'Sectores',
              visible: false,
              source: new ImageWMS({

                url: this.urlGeoserver,
                //params: {'LAYERS': URL_WS_V2+'sectores','STYLES': 'cat_sectores_only_label_sld', 'TILED': true},
                params: { 'LAYERS': 'gchc.catalogacion:sg02_lotes_bloques_n4', 'TILED': true },
                serverType: 'geoserver',
                // Countries have transparency, so do not fade tiles:
                //transition: 0,
              })
            }),
            new ImageLayer({
              //title: 'Sectores',
              visible: false,
              source: new ImageWMS({

                url: this.urlGeoserver,
                //params: {'LAYERS': URL_WS_V2+'sectores','STYLES': 'cat_sectores_only_label_sld', 'TILED': true},
                params: { 'LAYERS': 'gchc.catalogacion:sg02_lotes_bloques_n5', 'TILED': true },
                serverType: 'geoserver',
                // Countries have transparency, so do not fade tiles:
                //transition: 0,
              })
            }),
          ]
        }),
        /* SECTOR 03 */
        new LayerGroup({

          layers: [
            new ImageLayer({
              //title: 'Sectores',
              visible: false,
              source: new ImageWMS({

                url: this.urlGeoserver,
                //params: {'LAYERS': URL_WS_V2+'sectores','STYLES': 'cat_sectores_only_label_sld', 'TILED': true},
                params: { 'LAYERS': 'gchc.catalogacion:sg03_lotes_bloques_s1', 'TILED': true },
                serverType: 'geoserver',
                // Countries have transparency, so do not fade tiles:
                //transition: 0,
              })
            }),

            new ImageLayer({
              //title: 'Sectores',
              visible: false,
              source: new ImageWMS({

                url: this.urlGeoserver,
                //params: {'LAYERS': URL_WS_V2+'sectores','STYLES': 'cat_sectores_only_label_sld', 'TILED': true},
                params: { 'LAYERS': 'gchc.catalogacion:sg03_lotes_bloques_n1', 'TILED': true },
                serverType: 'geoserver',
                // Countries have transparency, so do not fade tiles:
                //transition: 0,
              })
            }),
            new ImageLayer({
              //title: 'Sectores',
              visible: false,
              source: new ImageWMS({

                url: this.urlGeoserver,
                //params: {'LAYERS': URL_WS_V2+'sectores','STYLES': 'cat_sectores_only_label_sld', 'TILED': true},
                params: { 'LAYERS': 'gchc.catalogacion:sg03_lotes_bloques_n2', 'TILED': true },
                serverType: 'geoserver',
                // Countries have transparency, so do not fade tiles:
                //transition: 0,
              })
            }),
            new ImageLayer({
              //title: 'Sectores',
              visible: false,
              source: new ImageWMS({

                url: this.urlGeoserver,
                //params: {'LAYERS': URL_WS_V2+'sectores','STYLES': 'cat_sectores_only_label_sld', 'TILED': true},
                params: { 'LAYERS': 'gchc.catalogacion:sg03_lotes_bloques_n3', 'TILED': true },
                serverType: 'geoserver',
                // Countries have transparency, so do not fade tiles:
                //transition: 0,
              })
            }),
            new ImageLayer({
              //title: 'Sectores',
              visible: false,
              source: new ImageWMS({

                url: this.urlGeoserver,
                //params: {'LAYERS': URL_WS_V2+'sectores','STYLES': 'cat_sectores_only_label_sld', 'TILED': true},
                params: { 'LAYERS': 'gchc.catalogacion:sg03_lotes_bloques_n4', 'TILED': true },
                serverType: 'geoserver',
                // Countries have transparency, so do not fade tiles:
                //transition: 0,
              })
            }),
            new ImageLayer({
              //title: 'Sectores',
              visible: false,
              source: new ImageWMS({

                url: this.urlGeoserver,
                //params: {'LAYERS': URL_WS_V2+'sectores','STYLES': 'cat_sectores_only_label_sld', 'TILED': true},
                params: { 'LAYERS': 'gchc.catalogacion:sg03_lotes_bloques_n5', 'TILED': true },
                serverType: 'geoserver',
                // Countries have transparency, so do not fade tiles:
                //transition: 0,
              })
            }),
          ]
        }),
        /* SECTOR 04 */
        new LayerGroup({

          layers: [
            new ImageLayer({
              //title: 'Sectores',
              visible: false,
              source: new ImageWMS({

                url: this.urlGeoserver,
                //params: {'LAYERS': URL_WS_V2+'sectores','STYLES': 'cat_sectores_only_label_sld', 'TILED': true},
                params: { 'LAYERS': 'gchc.catalogacion:sg04_lotes_bloques_s1', 'TILED': true },
                serverType: 'geoserver',
                // Countries have transparency, so do not fade tiles:
                //transition: 0,
              })
            }),

            new ImageLayer({
              //title: 'Sectores',
              visible: false,
              source: new ImageWMS({

                url: this.urlGeoserver,
                //params: {'LAYERS': URL_WS_V2+'sectores','STYLES': 'cat_sectores_only_label_sld', 'TILED': true},
                params: { 'LAYERS': 'gchc.catalogacion:sg04_lotes_bloques_n1', 'TILED': true },
                serverType: 'geoserver',
                // Countries have transparency, so do not fade tiles:
                //transition: 0,
              })
            }),
            new ImageLayer({
              //title: 'Sectores',
              visible: false,
              source: new ImageWMS({

                url: this.urlGeoserver,
                //params: {'LAYERS': URL_WS_V2+'sectores','STYLES': 'cat_sectores_only_label_sld', 'TILED': true},
                params: { 'LAYERS': 'gchc.catalogacion:sg04_lotes_bloques_n2', 'TILED': true },
                serverType: 'geoserver',
                // Countries have transparency, so do not fade tiles:
                //transition: 0,
              })
            }),
            new ImageLayer({
              //title: 'Sectores',
              visible: false,
              source: new ImageWMS({

                url: this.urlGeoserver,
                //params: {'LAYERS': URL_WS_V2+'sectores','STYLES': 'cat_sectores_only_label_sld', 'TILED': true},
                params: { 'LAYERS': 'gchc.catalogacion:sg04_lotes_bloques_n3', 'TILED': true },
                serverType: 'geoserver',
                // Countries have transparency, so do not fade tiles:
                //transition: 0,
              })
            }),
            new ImageLayer({
              //title: 'Sectores',
              visible: false,
              source: new ImageWMS({

                url: this.urlGeoserver,
                //params: {'LAYERS': URL_WS_V2+'sectores','STYLES': 'cat_sectores_only_label_sld', 'TILED': true},
                params: { 'LAYERS': 'gchc.catalogacion:sg04_lotes_bloques_n4', 'TILED': true },
                serverType: 'geoserver',
                // Countries have transparency, so do not fade tiles:
                //transition: 0,
              })
            }),
            new ImageLayer({
              //title: 'Sectores',
              visible: false,
              source: new ImageWMS({

                url: this.urlGeoserver,
                //params: {'LAYERS': URL_WS_V2+'sectores','STYLES': 'cat_sectores_only_label_sld', 'TILED': true},
                params: { 'LAYERS': 'gchc.catalogacion:sg04_lotes_bloques_n5', 'TILED': true },
                serverType: 'geoserver',
                // Countries have transparency, so do not fade tiles:
                //transition: 0,
              })
            }),
          ]
        }),

      ],


      view: this.view,
      overlays: [this.overlay]
    });

    //--------------------------------------------------------------------------------------------------
    // Implementación del Layer Group ------------------------------------------------------------------
    //--------------------------------------------------------------------------------------------------
    function bindInputs(layerid, layer) {
      var visibilityInput = $(layerid + ' input.visible');
      visibilityInput.on('change', function () {
        layer.setVisible(this.checked);
      });
      visibilityInput.prop('checked', layer.getVisible());

      var opacityInput = $(layerid + ' input.opacity');
      opacityInput.on('input', function () {
        layer.setOpacity(parseFloat(this.value));
      });
      opacityInput.val(String(layer.getOpacity()));
    };

    function setup(id, group) {
      group.getLayers().forEach(function (layer, i) {
        var layerid = id + i;
        bindInputs(layerid, layer);
        if (layer instanceof LayerGroup) {
          setup(layerid, layer);
        }
      });
    }
    setup('#layer', this.map.getLayerGroup());



    //--------------------------------------------------------------------------------------------------
    // END - Implementación del Layer Group ------------------------------------------------------------
    //--------------------------------------------------------------------------------------------------

    this.map.on('click', (evt) => {

      //console.log(this.view.getResolution());

      document.getElementById('info').innerHTML = '';
      var viewResolution = /** @type {number} */
        (this.view.getResolution());
      var url = this.lotesWmsSource.getFeatureInfoUrl(
        evt.coordinate,
        viewResolution,
        'EPSG:3857',
        //{'INFO_FORMAT': 'text/html'},
        { 'INFO_FORMAT': 'application/json' },
      );
      /*
      if (url) {
        fetch(url)
          .then(function (response) { return response.text(); })
          .then(function (html) {
            document.getElementById('info').innerHTML = html;
          });
      }
      */
      if (url) {
        fetch(url)
          .then((response) => {
            return response.text();
            //    console.log(response.text());

          })
          .then((html) => {
            //document.getElementById('info').innerHTML = html;
            //convirtiendo a objeto JSON
            var info_lote = JSON.parse(html);
            console.log('loti: ', info_lote.features)

            //-------------------
            var coordinate = evt.coordinate;
            var hdms = toStringHDMS(olProj.toLonLat(coordinate));
            var foto = info_lote.features[0].properties.codregistr;

            //document.getElementById('info').innerHTML = '';
            this.infoElemento = info_lote.features[0].properties;
            this.viewPopup = true;


            //-------------------------------------------------------
            /*
            document.getElementById('popup-content').innerHTML = 
              '<p class=\'item-line-pop-up\'> <img width=200 src=\'http://172.16.7.144/registrofotografico/'+foto.substring(0,10)+'/arquitectonica/F21.jpg\'>' +
              '<p class=\'item-line-pop-up\'> Reg.Foto.: <b><a href=\'http://172.16.7.144/registrofotografico/'+foto.substring(0,10) +'\' target="_blank">'+ 'http://172.16.7.144/registrofotografico/'+foto.substring(0,10)+'</a></b></p>' +
              '<p class=\'item-line-pop-up\'> Cod.Lote: <b><a >'+ info_lote.features[0].properties.cod_lote+'</a></b></p>' +
              '<p class=\'item-line-pop-up\'> Cod.Ficha: <b><a href=\''+ info_lote.features[0].properties.cod_catalo +'\'>'+ info_lote.features[0].properties.cod_catalo+'</a></b></p>' +
              '<p class=\'item-line-pop-up\'> Sector: <b><a href=\'http://172.16.7.144/catalogacion/sector/'+info_lote.features[0].properties.cod_sector+'\'>'+ info_lote.features[0].properties.cod_sector+'</a></b></p>' +
              '<p class=\'item-line-pop-up\'> Barrio: <b><a href=\'http://172.16.7.144/catalogacion/barrio/'+info_lote.features[0].properties.barrio_1+'\'>'+ info_lote.features[0].properties.barrio_1+'</a></b></p>' +
              '<p class=\'item-line-pop-up\'> Cat. Catalogación: <b><a href=\'http://172.16.7.144/catalogacion/barrio/'+info_lote.features[0].properties.catcatalog+'\'>'+ info_lote.features[0].properties.catcatalog+'</a></b></p>' +
              '<p class=\'item-line-pop-up\'> Cat. Zonificación: <b><a href=\'http://172.16.7.144/catalogacion/barrio/'+info_lote.features[0].properties.catzonific+'\'>'+ info_lote.features[0].properties.catzonific+'</a></b></p>' +
              '<p class=\'item-line-pop-up\'> Dirección: <b><a href=\'http://172.16.7.144/catalogacion/barrio/'+info_lote.features[0].properties.dirección+'\'>'+ info_lote.features[0].properties.dirección+'</a></b></p>' +
              '<p class=\'item-line-pop-up\'> Filiación Cult.: <b><a href=\'http://172.16.7.144/catalogacion/barrio/'+info_lote.features[0].properties.fil_cultur+'\'>'+ info_lote.features[0].properties.fil_cultur+'</a></b></p>' +
              '<p class=\'item-line-pop-up\'> Nro. Res. Patrim.: <b><a href=\'http://172.16.7.144/catalogacion/barrio/'+info_lote.features[0].properties.nreslpatri+'\'>'+ info_lote.features[0].properties.nreslpatri+'</a></b></p>' +
              '<code class=\'item-line-pop-up text-grey\'> coord. [' + hdms + ']</code>' ;
              */
            //----------------

            //----------------
            console.log('coordinate: ' + coordinate);
            this.overlay.setPosition(coordinate);

            // info_box_html.innerHTML = 'result: '+info_lote.features[0].properties.direcci_1;

            // ver_info(info_lote.features[0].properties)

            //----------------
            var folder = this.urlWebServer + '/registrofotografico/' + foto.substring(0, 10);
            $.ajax({
              url: folder,
              success: function (data) {
                $(data).find("a").attr("href", function (i, val) {
                  $("body").append("<img src='" + folder + '/' + val + "'>");
                });
              }
            });
            //----------------
          });
      }
    });

    //this.infoElemento={"saludo": "Hola Mapa"}
  }

  // funciones del Componente-------------
  verFicha() {
    alert('por implementar')
  }

  cargarFicha(nroficha: string) {
    //alert(nroficha.substr(0,10));
    this.fichaService.traerFichaArquitectonica(nroficha.substr(0, 10)).subscribe(ficha => {
      this.infoFichaCatalogacion = ficha[0];
      
      console.log('FICHAAAAAA: ', ficha[0]);
      
    });

    //ACTUALIZADO---------------------------------------------------------

    this._reporteGeneralFichaService.traerReporteGeneralFicha(nroficha.substr(0,10)).subscribe(ficha => {
      this.infoFichaResumen = ficha[0];

      console.log('FICHA-RESUMEN: ', this.infoFichaResumen);

      const modalRef = this._modalService.open(ModalResumenFichaComponent)
      modalRef.componentInstance.ficha = ficha[0]
    })

  }

  cerrarPopup() {
    if (this.viewPopup) {
      this.viewPopup = false
    } else {
      this.viewPopup = true
    }
  }

  toggleTocMap() {
    if (this.viewTocMap) {
      this.viewTocMap = false
    } else {
      this.viewTocMap = true
    }
  }

}
